module.exports = __webpack_public_path__ + "download-icon.2bc629c8d79c432a6a65.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/download-icon.svg
// module id = ../../../../../src/img/icon/download-icon.svg
// module chunks = styles